// extracted by mini-css-extract-plugin
module.exports = {"statusWrapper":"styles_statusWrapper__3_kku","imageStatus":"styles_imageStatus__q_2L4","feedStatus":"styles_feedStatus__1Erxp","removeForMobile":"styles_removeForMobile__1iXe3"};